import { useMemo } from "react";

export default function usePaymentsTableOptions() {
    return useMemo(() => ({ heading: "Payments" }), [])
}